import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { TXTWCL_Bets_are_accepted_in_accordanc_ELL } from './SportsRulesLink.messages.json';
import styles from './SportsRulesLink.scss';

const SportsRulesLink: React.FC = () => (
  <div className={styles.wrapper} data-testid="sports-link-rules">
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink className={styles.rulesLink} resolverTag={ResolverTag.HelpGameSportsRules}>
            {msg}
          </ResolverLink>
        )
      }}
      {...TXTWCL_Bets_are_accepted_in_accordanc_ELL}
    />
  </div>
);

export default SportsRulesLink;
